import { Text } from '@viapeople/components'

interface UnavailableModulePanelProps {
	title: string
	moduleLabel: string
	dataTestid: string
}

/**
 * BGL has zero goals/360 cycles configured (verified on prod, see
 * memory/4374772881-20260430-1618.md §C.4 / §D.8). Rendering this placeholder
 * is faithful to Daniel's Apr 29 BGL comment and avoids fabricating data.
 */
export function UnavailableModulePanel({ title, moduleLabel, dataTestid }: UnavailableModulePanelProps) {
	return (
		<div
			data-testid={dataTestid}
			className='flex flex-col items-center justify-center h-64 p-6 border border-dashed border-neutral-300 rounded-lg bg-neutral-50'>
			<Text variant='small' weight='semibold' className='mb-1'>
				{title}
			</Text>
			<Text variant='hint' className='text-center text-neutral-500'>
				{moduleLabel} is not configured for this organization. Contact your administrator to enable {moduleLabel}{' '}
				tracking.
			</Text>
		</div>
	)
}
